import React from "react";
import SeoTable from "./components/SeoTable";

function CategorySeoTable() {
  return <SeoTable entityType="category" />;
}

export default CategorySeoTable;
